import { createReducer } from '@reduxjs/toolkit';
import type { IAnonymousAppointment, IAppointment, IAppointmentBranch, IAppointmentSettings, ICustomerBase, IRule, ITimeslot, ITopic } from '../../api/domain';
import {
    bookAppointmentAnonymousSuccess,
    bookAppointmentSuccess,
    clearBookedAppointment,
    fetchBranchesSuccess,
    fetchRelationshipManagerTimeslotsSuccess,
    fetchRulesSuccess,
    fetchSettingsSuccess,
    fetchTimeslotsSuccess,
    fetchTopicsSuccess,
    selectCustomerBaseForAppointment,
} from './appointments-api-actions';

interface IAppointmentsApiState {
    topics: ITopic[];
    branches?: IAppointmentBranch[];
    timeslots: ITimeslot[];
    rmTimeslots: ITimeslot[];
    settings: IAppointmentSettings;
    rules: IRule[];
    bookedAppointment?: IAppointment;
    bookedAnonymousAppointment?: IAnonymousAppointment;
    selectedCustomerBaseForAppointment?: ICustomerBase;
}
export type { IAppointmentsApiState };

export const initialState: IAppointmentsApiState = {
    topics: [],
    timeslots: [],
    rmTimeslots: [],
    branches: undefined,
    settings: {
        moduleEnabled: false,
        bookableWeekDays: [],
        contactFormRecipient: '',
        maxNumberOfWeeksInAdvance: 1,
        maxSlotsPerHour: 1,
        meetingsExchangeAppointmentSubject: '',
        numberOfWeeksInAdvance: 1,
        workdayEndHour: 1,
        workdayStartHour: 1,
        l10nAppointmentBookingDescription: [],
        l10nAppointmentBookingSubject: [],
        l10nIcalCommentTemplate: [],
        l10nIcalFilename: [],
        l10nIcalSubjectTemplate: [],
    },
    rules: [],
};

export const appointmentsApiReducer = createReducer(initialState, (builder) => {
    builder
        .addCase(fetchTopicsSuccess, (state, { payload: topics }) => {
            state.topics = topics;
        })
        .addCase(selectCustomerBaseForAppointment, (state, { payload: selectedCustomerBaseForAppointment }) => {
            state.selectedCustomerBaseForAppointment = selectedCustomerBaseForAppointment;
        })
        .addCase(fetchBranchesSuccess, (state, { payload: branches }) => {
            state.branches = branches;
        })
        .addCase(fetchSettingsSuccess, (state, { payload: settings }) => {
            state.settings = settings;
        })
        .addCase(fetchTimeslotsSuccess, (state, { payload: timeslots }) => {
            state.timeslots = timeslots;
        })
        .addCase(fetchRelationshipManagerTimeslotsSuccess, (state, { payload: rmTimeslots }) => {
            state.rmTimeslots = rmTimeslots;
        })
        .addCase(fetchRulesSuccess, (state, { payload: rules }) => {
            state.rules = rules;
        })
        .addCase(bookAppointmentSuccess, (state, { payload: bookedAppointment }) => {
            state.bookedAppointment = bookedAppointment;
        })
        .addCase(clearBookedAppointment, (state) => {
            state.bookedAppointment = undefined;
        })
        .addCase(bookAppointmentAnonymousSuccess, (state, { payload: bookedAnonymousAppointment }) => {
            state.bookedAnonymousAppointment = bookedAnonymousAppointment;
        });
});

export default appointmentsApiReducer;
